@defer (when asset()) {
  <article>
    <div class="flex">
      <app-page-title [canGoBack]="true" (click)="back()" class="flex-1"> {{ subtitle }}</app-page-title>
      <app-chip [label]="rangeText" [canClick]="false" />
    </div>

    <div>
      <div class="tabview-list">
        <div [class.active]="defaultTab === 0" (click)="handleTabChange(0)"><i class="mdi mdi-text-box-edit-outline"></i> Configuration</div>
        <div [class.active]="defaultTab === 1" (click)="handleTabChange(1)" title="updated {{ asset().updatedAt | date: 'dd/MM/yy HH:mm' }}"><i class="mdi mdi-chart-line"></i> Query</div>
        <div></div>
      </div>

      @switch (defaultTab) {
        @default {
          <div>
            @if (!setpoints()) {
              <i class="mdi mdi-loading mdi-spin-x2"></i>
            } @else {
              <section class="mb-1">
                <div style="display: none">
                  <div>Operational hours</div>
                  <div>Contacts</div>
                </div>
                <div>
                  <app-toolbar>
                    @if (asset().rag === 'amber' || asset().rag === 'red') {
                      <span class="rag-{{ asset().rag }}">{{ asset().rag }}</span>
                    }
                    <div class="left"></div>
                    <div class="right">
                      @if (!isUpdating) {
                        <app-button (click)="updateSetPoints()" class="mt-1 mb-1" icon="mdi mdi-check" label="Update" />
                      } @else {
                        <app-button>
                          <span><i class="mdi mdi-loading mdi-spin-x2"></i> Updating...</span>
                        </app-button>
                      }
                    </div>
                  </app-toolbar>

                  <div class="setpoint-edit" [class.in-error]="errorMessage()?.section === 'setpoint'">
                    <table class="table table-sm setpoint-table mt-1" aria-label="Setpoints">
                      <thead>
                        <th>Day</th>
                        <th tooltipPosition="left" [title]="rangeId === 3 ? 'Trigger before this time' : 'Trigger from this time'">
                          @switch (rangeId) {
                            @case (3) {
                              <span
                                >Trigger
                                <p>Before</p></span
                              >
                            }
                            @case (2) {
                              <span>From</span>
                            }
                          }
                        </th>
                        <th tooltipPosition="left" [title]="rangeId === 3 ? 'Trigger after this time' : 'Trigger before this time'">
                          @switch (rangeId) {
                            @case (3) {
                              <span
                                >Trigger
                                <p>After</p></span
                              >
                            }
                            @case (2) {
                              <span>To</span>
                            }
                          }
                        </th>
                        <th class="rag-red" [ngClass]="{ enabled: alarms().red_min }">
                          Red Min
                          <p title="Enable alarm - Red minimum breached" tooltipPosition="top">
                            <label class="switch" title=""><input name="typetoggle" type="checkbox" [(ngModel)]="alarms().red_min" (click)="linkRule()" /><span class="checkboxslider alarm round"></span> </label>
                          </p>
                        </th>
                        <th class="rag-amber" [ngClass]="{ enabled: alarms().amber_min }">
                          Amber Min
                          <p title="Enable alarm - Amber minimum breached" tooltipPosition="top">
                            <label class="switch" title=""><input name="typetoggle" type="checkbox" [(ngModel)]="alarms().amber_min" (click)="linkRule()" /><span class="checkboxslider alarm round"></span> </label>
                          </p>
                        </th>
                        <th class="green-gap">
                          Green
                          <p></p>
                        </th>
                        <th class="rag-amber" [ngClass]="{ enabled: alarms().amber_max }">
                          Amber Max
                          <p title="Enable alarm - Amber maximum breached" tooltipPosition="top">
                            <label class="switch" title=""><input name="typetoggle" type="checkbox" [(ngModel)]="alarms().amber_max" (click)="linkRule()" /><span class="checkboxslider alarm round"></span> </label>
                          </p>
                        </th>
                        <th class="rag-red" [ngClass]="{ enabled: alarms().red_max }">
                          Red Max
                          <p title="Enable alarm - Red maximum breached" tooltipPosition="top">
                            <label class="switch" title=""><input name="typetoggle" type="checkbox" [(ngModel)]="alarms().red_max" (click)="linkRule()" /><span class="checkboxslider alarm round"></span> </label>
                          </p>
                        </th>
                        @if (rangeId === 2) {
                          <th class="all-day">All Day</th>
                        }

                        <th>Enabled</th>
                        <th></th>
                      </thead>
                      <tbody>
                        @for (setpoint of setpoints(); track setpoint; let i = $index) {
                          <tr [class.chart-clicked-weekday]="selectedWeekday === i" [class.forCopy]="copySetpoint && copySetpoint.asset.id === asset().id && copySetpoint.index === i">
                            <td>
                              {{ weekdays[i].title }}
                            </td>

                            @if (!setpoint.allday) {
                              <td>
                                <input type="time" [(ngModel)]="setpoint.startsAt" (blur)="onBlur()" [disabled]="!setpoint.isActive" (keyup)="generateGreenRAGTooltip()" />
                              </td>
                            } @else {
                              <td>00:00:00</td>
                            }

                            @if (!setpoint.allday) {
                              <td>
                                <input type="time" [(ngModel)]="setpoint.endsAt" (blur)="onBlur()" [disabled]="!setpoint.isActive" (keyup)="generateGreenRAGTooltip()" />
                              </td>
                            } @else {
                              <td>23:59:59</td>
                            }

                            <td class="rag-red">
                              <input [(ngModel)]="setpoint.red_min" style="width: 60px" [disabled]="!setpoint.isActive" (blur)="change('red_min')" (keyup)="generateGreenRAGTooltip()" />
                            </td>
                            <td class="rag-amber">
                              <input [(ngModel)]="setpoint.amber_min" style="width: 60px" [disabled]="!setpoint.isActive" (blur)="change('amber_min')" (keyup)="generateGreenRAGTooltip()" />
                            </td>
                            <td class="green-gap" [title]="setpoint.tooltips?.green"></td>
                            <td class="rag-amber">
                              <input [(ngModel)]="setpoint.amber_max" style="width: 60px" [disabled]="!setpoint.isActive" (blur)="change('amber_max')" (keyup)="generateGreenRAGTooltip()" />
                            </td>

                            <td class="rag-red">
                              <input [(ngModel)]="setpoint.red_max" style="width: 60px" [disabled]="!setpoint.isActive" (blur)="change('red_max')" (keyup)="generateGreenRAGTooltip()" />
                            </td>
                            @if (rangeId === 2) {
                              <td class="all-day">
                                <label class="switch" title="Enable to run all day"><input name="typetoggle" type="checkbox" [(ngModel)]="setpoint.allday" (click)="allday(i)" /><span class="checkboxslider round"></span></label>
                              </td>
                            }
                            <td>
                              <label class="switch" title="Enable this line"><input name="typetoggle" type="checkbox" [(ngModel)]="setpoint.isActive" (click)="enableWeekday(i)" /><span class="checkboxslider round"></span></label>
                            </td>

                            <td class="actions">
                              <i class="mdi mdi-content-copy" [class.disabled]="!setpoint.isActive" title="Copy" tooltipPosition="left" (click)="copy(i)"></i>

                              <i class="mdi mdi-content-paste" [class.disabled]="!copySetpoint" title="Paste" tooltipPosition="left" (click)="paste(i)"></i>
                            </td>
                          </tr>
                        }
                      </tbody>
                    </table>

                    @if (errorMessage()?.section === 'setpoint') {
                      <div class="error-message">
                        {{ errorMessage()?.message }}
                      </div>
                    }
                  </div>

                  <div class="explorer-container hidden-xs hidden-sm">
                    <app-asset-chart [showCurrentValue]="false" theme="white" [asset]="asset()" [setpoints]="setpoints()" (onBlockClicked)="assetChartBlockClicked($event)" [showPoints]="true" />
                  </div>
                  <div class="delay-container">
                    <div class="delay">
                      <div>
                        <h4><i class="mdi mdi-timer-pause-outline"></i> Delay in minutes</h4>
                        <input max="1000" min="0" type="number" [(ngModel)]="master.delay" style="font-size: 18px" (blur)="onBlur()" />
                        <span style="font-style: italic"> Delay in minutes before the setpoint triggers Red or Amber.</span>
                        @if (errorMessage()?.section === 'delay') {
                          <div class="error-message mt-1">
                            {{ errorMessage()?.message }}
                          </div>
                        }
                      </div>
                    </div>
                  </div>

                  <div class="notifications">
                    <div>
                      <div class="notification-container">
                        <div>
                          <h4><i class="mdi mdi-account-group-outline"></i> User groups</h4>
                        </div>
                        <div>
                          <app-button-notifications [groupings]="groupings()" (onUpdate)="updateNotifications($event)" />
                        </div>
                      </div>

                      <div class="table-wrapper">
                        @if (groupings().length) {
                          <table class="table table-sm" aria-label="groups">
                            <tbody>
                              @for (grouping of groupings(); track grouping.title) {
                                <tr>
                                  <td>{{ grouping.title }}</td>
                                </tr>
                              }
                            </tbody>
                          </table>
                        } @else {
                          <p>No user groups selected.</p>
                        }
                      </div>

                      <div class="notification-container">
                        <div>
                          <span title="Toggle site notifications" tooltipPosition="top" (click)="toggleSiteNotifications()" class="can-click"><i class="fa fa-fw" [class.fa-square-o]="!master.hasSiteNotifications" [class.fa-check-square-o]="master.hasSiteNotifications"></i> Site notifications {{ !master.hasSiteNotifications ? ' off' : '' }}</span>
                        </div>
                        <div></div>
                      </div>

                      <div class="table-wrapper" [class.is-disabled]="!master.hasSiteNotifications">
                        <table class="table table-sm users" aria-label="users">
                          <thead>
                            <tr>
                              <th>Name</th>
                              <th>Email</th>
                            </tr>
                          </thead>
                          <tbody>
                            @for (contact of contacts; track contact.email) {
                              <tr>
                                <!-- Site contacts -->
                                <td>{{ contact.name }}</td>
                                <td class="text-left">{{ contact.email }}</td>
                              </tr>
                            }
                          </tbody>
                        </table>
                        @if (contacts.length === 0) {
                          <p>No contacts defined for the site.</p>
                        }
                      </div>
                    </div>
                  </div>

                  <div class="instructions">
                    <h4 title="This will be included in the alarm's email"><i class="mdi mdi-email-outline"></i> Alarm Instructions</h4>
                    <textarea class="fourd" [(ngModel)]="master.instructions" rows="4"></textarea>
                  </div>

                  <div class="notes">
                    <h4 title="Notes about the setpoint"><i class="mdi mdi-note-edit-outline"></i> Notes</h4>
                    <textarea class="fourd" [(ngModel)]="master.notes" rows="4"></textarea>
                  </div>

                  <div class="text-right">
                    <app-button (click)="updateSetPoints()" class="mt-1 mb-1" icon="mdi mdi-check" label="Update" />
                  </div>
                </div>
              </section>
            }
          </div>
        }
        @case (1) {
          <app-setpoint-query [asset]="asset()"></app-setpoint-query>
        }
      }
    </div>
  </article>
} @placeholder (minimum 100ms) {}

@if (loading || isUpdating) {
  <app-please-wait></app-please-wait>
}
